import { Currency } from '@commenda/prisma';
import { TSerializedItem } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { affiliateQuotesKeys } from './keys';

const getAffiliateServices = async (
  affiliateFirmId: string,
  currency: Currency
) => {
  const response = await fetcher(
    `affiliate-firms/${affiliateFirmId}/quotes/available-services?currency=${currency}`,
    {
      method: 'GET',
    }
  );

  return response.json();
};

const useAffiliateServices = ({
  affiliateFirmId,
  currency,
}: {
  affiliateFirmId: string;
  currency: Currency;
}): UseQueryResult<TSerializedItem[], Error> => {
  return useQuery({
    queryFn: () => getAffiliateServices(affiliateFirmId, currency),
    queryKey: affiliateQuotesKeys.FETCH_AFFILIATE_SERVICES(
      affiliateFirmId,
      currency
    ),
    staleTime: 0,
    refetchOnMount: true,
  });
};

export { useAffiliateServices };
